import React, {useEffect, useState} from 'react';
import Header from "../components/header/Header";
import {Flex, Skeleton} from "antd";
import ProductDescription from "../components/productDescription/ProductDescription";
import ProductImages from "../components/productImages/ProductImages";
import ActionButtons from "../components/actionButtons/ActionButtons";
import {connect} from "react-redux";
import {EmptyMessage, getCities, getProductSubCategoryList} from "../../../shared";
import {getProductDetail} from "../../product/actions/Product.action";
import {withRouter} from "../../../utils/services/with-router";
import {AdminPanelProps} from "../models";
import {getAdminPanelProduct} from "../actions/AdminPanel.action";

const AdminPanel = ({getAdminPanelProduct} : AdminPanelProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<any>([]);
    const [currentIndex, setCurrentIndex] = useState<number>(0);

    const _getAdminPanelProduct = () => {
        setCurrentIndex(0)
        setLoading(true);
        getAdminPanelProduct()
            .then((data: any) => {
                setLoading(false);
                if (data.payload != undefined) {
                 setData(data.payload.data);

                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        _getAdminPanelProduct()
    }, []);
    useEffect(() => {
        console.log(currentIndex)
        if (currentIndex === 10)
        _getAdminPanelProduct()
    }, [currentIndex]);
    return (
        <Flex vertical gap={"middle"}>
            <Header/>
            {(data?.length === 0 && !loading) && <EmptyMessage message={"آگهی در حال حاضر موجود نیست !"}/>}

            {loading &&  <Flex vertical >
                <Skeleton round active/>
                <Skeleton round active/>
                <Skeleton round active/>
            </Flex>}
            {data?.length > 0 && <Flex vertical gap={"middle"}>
                <ProductDescription data={data[currentIndex]?.description}/>
                <ProductImages imageList={data[currentIndex]?.image_urls}/>
                <ActionButtons id={data[currentIndex]?.id} onSubmitBtnClick={() => setCurrentIndex(currentIndex+1)}/>
            </Flex>}
        </Flex>
    );
};

export default connect(null, {getAdminPanelProduct})(withRouter(AdminPanel));
